<template>
  <div class="flex-start-md">
    <p>
      <i18n-t keypath="NotificationsComponent.SeatEnforcementCurrentStatus" tag="span" scope="global">
        <template #activeDevices>
          {{ seatData.activeDevices }}
        </template>
        <template #planDevices>
          {{ seatData.planDevices }}
        </template>
        <template #overDevices>
          {{ seatData.overDevices }}
        </template>
        <template #newPlanDevices>
          {{ seatData.newPlanDevices }}
        </template>
      </i18n-t>
    </p>
  </div>
</template>

<script setup lang="ts">
import { PropType, computed } from "vue";
import { INotification } from "@/stores/notificationsInterfaces";

const props = defineProps({
  notification: {
    type: Object as PropType<INotification>,
    required: true,
  },
});

const seatData = computed(() => {
  const params = props.notification?.params;
  // Use new descriptive names with fallback to legacy digit properties
  const activeDevices = params?.seatEnforcementParams?.activeDevices ?? 0;
  const planDevices = params?.seatEnforcementParams?.planDevices ?? 0;
  const newPlanDevices = params?.seatEnforcementParams?.newPlanDevices ?? 0;

  return {
    activeDevices: activeDevices || "",
    planDevices: planDevices || "",
    overDevices: Math.max(0, activeDevices - planDevices),
    newPlanDevices: newPlanDevices || "",
  };
});
</script>
